import { Spinner, Modal } from "react-bootstrap";

const Loader = ({ loading }) => (
  <Modal show={loading} centered backdrop="static" keyboard={false}>
    <Modal.Body className="d-flex justify-content-center align-items-center">
      <Spinner animation="border" role="status" />
      <p
        style={{
          color: "black",
          fontSize: 21,
          marginLeft: 10,
          marginTop: 10,
          fontFamily: "sans-serif",
        }}
      >
        Loading...
      </p>
    </Modal.Body>
  </Modal>
);

export default Loader;
